<template>
  <div class="task-temp" v-loading="loading">
    <template v-for="item in dataset" >
      <div class="task-temp--item" :key="item.project_id" v-if="item.project_task_list && item.project_task_list.length > 0">
        <div class="task-temp--header"  @click="openProject(item.project_id)">
          <toolTip :title="item.title">{{item.title}}</toolTip>
          <i class="iconfont iconicon_arrow_task_1"></i>
        </div>
        <div class="task-temp--box">
          <template v-for="temp in item.project_task_list">
            <div class="task-temp--content" :key="temp.task_list_id" v-if="temp.new_tasks && temp.new_tasks.length > 0">
              <div class="content--order">
                <div class="content--order-in" @click="toggleShow(temp)">
                  <div class="close-box" >
                    <i class="icon iconfont iconicon_drop_down_arrow" :class="{'rota90': !temp.close}"></i>
                  </div>
                  <toolTip :title="temp.title">{{temp.title}}</toolTip>
                </div>
                <!-- <i class="iconfont iconicon_enlarge taskHoverIcon"  @click="addTask(item.project_id, temp.task_list_id)"></i> -->
              </div>
              <el-collapse-transition>
              <div class="task--box" v-if="!temp.close && temp.new_tasks && temp.new_tasks.length > 0">
                <div class="content--task" v-for="val in temp.new_tasks" :key="val.id" :class="dateAlert(val)" @click="openTask(val)">
                  <div class="task-badge" v-if="val.msgcount"></div>
                  <div class="task--title">
                    <toolTip :title="val.task_name" style="width: 100%;">{{val.task_name}}</toolTip>
                  </div>
                  <div class="task--footer">
                    <span class="task-date">{{resetTime(val.end_time)}}</span>
                    <TaskLevel :level="val.sort_rule.sort"></TaskLevel>
                  </div>
                </div>
              </div>
              </el-collapse-transition>
            </div>
          </template>
        </div>
      </div>
    </template>
    <nothing :config="{}" v-if="!loading && dataset && dataset.length === 0"></nothing>
    <AddTask v-model="visibleAddTask" :project_id="project_id" :task_list_id="task_list_id" @addSuccess="addSuccess"></AddTask>
    <WfTip v-model="showIsNullFirst" :config="{content: tipContent}" @contentClick="contentClick" @close="closeTip"></WfTip>
  </div>
</template>
<script>
import TaskLevel from '@/components/taskLevel'
import QuickDialog from './quickDialog'
import ProjectNewsDialog from '@/views/main/myProject/starProject/projectNewsDialog.vue'
import { dateReminder } from "@/utils";
import AddTask from "@/views/task/taskPanel/addTask";
import hApi from '@/services/api/home/home'
import { mapMutations, mapState, mapGetters } from 'vuex'
import bus from '@/bus'
import {
  Storage
} from '@/utils/utils';
export default {
  components: {
    TaskLevel,
    AddTask,
    QuickDialog,
    ProjectNewsDialog
  },
  data() {
    return {
      visibleAddTask: false,
      project_id: '',
      task_list_id: '',
      dataset: [],
      loading: false,
      showTip: false,
      tipContent: '工作台空空如也怎么办？去<span id="wordNullId">帮助中心</span> 了解详情吧～',
      params: {
        page:1,
        number: 9999,
        executor: ''
      }
    }
  },
  computed: {
    ...mapState('task/task', {
      isOnlyMyExecutor: state => state.isOnlyMyExecutor
    }),
    ...mapGetters("layout/layout", ['userInfo']),
    showIsNullFirst: {
      get() {
        return this.showTip && !this.loading && this.dataset.length === 0
      },
      set() {

      }
    }
  },
  watch: {
    isOnlyMyExecutor: {
      handler() {
        if(this.isOnlyMyExecutor) {
          this.params.executor = this.userInfo.uid
        } else {
          delete this.params.executor
        }
        this.init()
      },
      immediate: true
    }
  },
  created() {
    let uses = Storage.get('wfUserInfo')
    this.showTip = !Storage.get(`${uses.uid}tipContent`)
  },
  mounted() {
    bus.$on('updateTask', () => {
      this.init()
    })
    bus.$on('sendMessageReal', () => {
      this.init()
    })
    // this.$wfTip({
    //   content: '工作台空空如也怎么办？去<span id="wordNullId">帮助中心</span> 了解详情吧～',
    //   contentClick: e => {
    //     if(e.target.id === 'wordNullId') {
    //       this.$router.push('/helpPage')
    //     }
    //   }
    // })
  },
  methods: {
    ...mapMutations("task/task", ["CHANGE_TASK"]),
    closeTip() {
      let uses = Storage.get('wfUserInfo')
      Storage.set(`${uses.uid}tipContent`, true)
    },
    async init() {
      this.loading = true
      let result = await hApi.getMyUnfinishTaskOfTheProjectList(this.params)
      this.dataset = result.data
      this.loading = false
    },
    dateAlert(item) {
      return dateReminder(item)
    },
    addSuccess() {
      this.init()
    },
    addTask(project_id, project_list_id) {
      this.project_id = project_id
      this.task_list_id = project_list_id
      this.visibleAddTask = true
    },
    openTask(task) {
      let task_id = task.id
      let task_list_id = task.task_list_id
      task.msgcount = 0
      this.CHANGE_TASK({ visible: true, task_id, task_list_id })
    },
    openProject(id) {
      this.$router.push(`/task?projectId=${id}&isTabShow=true`)
    },
    toggleShow(temp) {
      this.$set(temp, 'close', !temp.close)
    },
    contentClick(e) {
      if(e.target.id === 'wordNullId') {
        this.$router.push('/helpPage')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.task-temp {
  height: 0;
  flex: 1;
  display: flex;
  overflow-y: auto;
  position: relative;
  background-color: #F7F7F7;
  &::-webkit-scrollbar-track-piece {
    background-color: #E6E6E6;
  }
  &::-webkit-scrollbar {
    width: 6px;
    height: 24px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 0;
    background-color: #D5D5D5;
    &:active, &:hover {
      background-color: #9199A7;
    }
  }
  .task-badge {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: linear-gradient(227deg, #7aa7e2 0%, #456fb3 100%);
    border-radius: 50%;
    flex-shrink: 0;
    position: absolute;
    right: -1px;
    top: -1px;
  }
  .task-temp--item {
    width: 288px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-shrink: 0;
    border-right: 1px solid rgba(13, 37, 60, 0.08);
  }
  .task-temp--header {
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    &:hover {
      background-color: #EEEEEE;
    }
    &:active {
      background-color: #E6E6E6;
    }
    i {
      color: #778191;
      font-size: 14px;
      font-weight: 400;
    }
    /deep/ {
      .tool-tip {
        width: 0;
        flex: 1;
      }
    }
  }
  .task-temp--box {
    overflow-x: hidden;
    overflow: overlay;
    height: 0;
    flex: 1;
    padding-bottom: 16px;
    &::-webkit-scrollbar {
      display: none;
    }
    .task-temp--content:first-child .content--order {
      padding-top: 20px;
    }
  }
  .task-temp--content {
    padding: 0 16px;
    padding-bottom: 20px;
  }
  .task--box {
    display: flex;
    flex-direction: column;
    grid-row-gap: 8px ;
  }
  .content--task {
    position: relative;
    background-color: #fff;
    box-shadow: 0px 1px 4px 0px rgba(13,31,60,0.08);
    border-radius: 4px;
    height: 90px;
    padding: 16px;
    transition: all .3s;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    flex-shrink: 0;
    &:hover {
      box-shadow: 0px 6px 16px 0px rgba(58,73,96,0.27);
    }
    &:before {
      content: "";
      width: 3px;
      height: 100%;
      position: absolute;
      background-color: rgba(255, 255, 255, 0);
      border-radius: 50px 0 0 50px;
      top: 0;
      left: 0;
      bottom: 0;
    }
  }
  .content--order {
    font-size: 14px;
    // padding-top: 20px;
    display: flex;
    padding-bottom: 11px;
    display: flex;
    align-items: center;
    font-weight: 400;
    color: rgba(32, 32, 32, 0.6);
    /deep/ {
      .tool-tip {
        width: 0;
        flex: 1;
      }
    }
    .close-box {
      margin-right: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      i {
        font-size: 14px;
        color: rgba(32, 32, 32, 0.24);
        font-size: 12px;
        transition: all .3s;
      }
    }
  }
  .content--order-in {
    display: flex;
    align-items: center;
    width: 0;
    flex: 1;
    cursor: pointer;
    &:hover {
      color: initial;
      i {
        color: initial;
      }
    }
  }
  .task--title{
    font-size: 16px;
    font-weight: 500;
  }
  .task--footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .task-date {
    font-size: 13px;
    line-height: 18px;
    color: rgba(13, 31, 60, 0.8);
  }
  .remind {
    .task-date {
      color: #ff8b23 !important;
    }
    &:before {
      background-color: #ff8b23 !important;
    }
  }
  .expired {
    .task-date {
      color: #ff3939 !important;
    }
    &:before {
      background-color: #ff3939 !important;
    }
  }
}
</style>
